<template>
  <div class="contract_detail_wrapper">
    <div class="header">
      <div>
        <a-button icon="arrow-left" size="small" @click="() => $router.back()" />
        <span class="page_type">详情</span>
      </div>
    </div>
    <div class="content">
      <div class="common flex-row">
        <div class="left">
          <div class="basic-info">
            <div class="img-wrapper">
              <a-avatar shape="square" :size="26" :src="titlePrefix" />
            </div>
            <div>
              <div class="code">
                <span style="display: inline-block; width: 15em;">销售合同号：{{ detailInfo.pcCode }}</span>
                <span :class="`status-${detailInfo.state}`">
                {{ detailInfo.stateName }}
                </span>
              </div>
              <div class="customer">{{ detailInfo.unit }}_{{ detailInfo.businessTypeDesc }}_{{ detailInfo.signDate }}</div>
            </div>
          </div>
          <a-tabs default-active-key="1" @change="handleActiveChange">
            <a-tab-pane key="1" tab="合同信息">
            </a-tab-pane>
            <a-tab-pane key="2" tab="日志动态">
            </a-tab-pane>
            <a-tab-pane key="3" tab="附件信息">
            </a-tab-pane>
          </a-tabs>
        </div>
        <div class="bg_money_wrapper">
          <div class="title">合同金额</div>
          <div class="value">{{ materialList.reduce((pre, cur) => pre + cur.orderNum * cur.unitPrice, 0).toLocaleString('en-US', { minimumFractionDigits: 2 }) || '-' }}元</div>
        </div>
      </div>
      <template v-if="activeKey === '1'">
        <div class="common">
          <div class="title gap-12">基本信息</div>
          <el-descriptions :column="3">
            <el-descriptions-item label="销售模式">{{
              convertToName(decisionEnums, detailInfo.decision)
            }}</el-descriptions-item>
            <el-descriptions-item label="业务类型">{{
              detailInfo.businessTypeDesc | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="合同模版">{{
              detailInfo.templateName | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="客户抬头">{{
              detailInfo.unit | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="发票类型">{{
              detailInfo.invoiceTypeDesc | setEmpty
            }}</el-descriptions-item>
            <!-- <el-descriptions-item label="合同生效日期">{{
              detailInfo.effectiveDate | setEmpty
            }}</el-descriptions-item> -->
            <!-- <el-descriptions-item label="合同终止日期">{{
              detailInfo.dueDate | setEmpty
            }}</el-descriptions-item> -->
            <el-descriptions-item label="签订日期">{{
              detailInfo.signDate | setEmpty
            }}</el-descriptions-item>
            <!-- <el-descriptions-item label="签订地点">{{
              `${detailInfo.provinceName || ''}${detailInfo.cityName || ''}${detailInfo.areaName || ''}${detailInfo.signAddress || '--'}`
            }}</el-descriptions-item> -->
            <el-descriptions-item label="结算方式">{{
              detailInfo.payWayName | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="是否含税">{{
              detailInfo.isTaxName | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="税率">{{
              detailInfo.taxRate | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="客户联系人">{{
              detailInfo.salesmanName | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="联系人电话">{{
              detailInfo.salesmanPhone | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="联系人邮箱">{{
              detailInfo.email | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="变更状态">{{
              convertToName(changeStatesEnums, detailInfo.changeState)
            }}</el-descriptions-item>
            <el-descriptions-item label="创建人">{{
              detailInfo.createUserName | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="创建时间">{{
              detailInfo.createTime | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="收款账号" :span="3">{{
              `${detailInfo.account}_${detailInfo.bankName}`
            }}</el-descriptions-item>
            <!-- <el-descriptions-item v-if="type === 'detail'" label="审核意见">{{
              detailInfo.supIdea | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item v-if="type === 'detail'" label="合同状态">{{
              detailInfo.stateName | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item v-if="type === 'detail'" label="变更状态">{{
              detailInfo.changeStateName | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item v-if="type === 'detail'" label="变更意见">{{
              detailInfo.supChangeIdea | setEmpty
            }}</el-descriptions-item> -->
            <el-descriptions-item label="合同备注">{{
              detailInfo.remark | setEmpty
            }}</el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="common">
          <div class="title gap-12">物资信息</div>
          <div style="width: 100%; overflow: auto;">
            <xz-table
              ref="xzTable"
              :columns="suppliesColumns"
              :data="materialList"
              rowKey="id"
              style="min-width: 1600px;">
              <template slot="imageList" slot-scope="image">
                <span v-if="image && image.split(',').length > 0">
                  <span v-for="(img, i) in image.split(',')" :key="'img-'+i">
                    <el-image v-if="i < 2" style="width: 32px; height: 32px; margin-right: 5px;" :src="img" :preview-src-list="image.split(',')" />
                  </span>
                  <span v-if="image.split(',').length > 2" style="color:#3182bd; margin-left: 2px;">...</span>
                </span>
                <span v-else>暂无图片</span>
              </template>
              <template slot="footer" slot-scope="currentPageData">
                <div>
                  <b style="margin-right: 100px;">合计</b>
                  <b style="margin-right: 5px;">数量：{{ currentPageData.reduce((pre, cur) => pre + Number(cur.orderNum), 0) || '-' }}</b>
                  <b>，总金额：{{ currentPageData.reduce((pre, cur) => pre + cur.orderNum * cur.unitPrice, 0).toLocaleString('en-US', { minimumFractionDigits: 2 }) || '-' }}</b>
                </div>
              </template>
            </xz-table>
          </div>
        </div>
      </template>
      <template v-if="activeKey === '2'">
        <div class="common" style="padding-top: 0;">
          <xz-table ref="xzTable" :columns="logColumns" :data="logData" rowKey="id"></xz-table>
        </div>
      </template>
      <template v-if="activeKey === '3'">
        <div class="common">
          <div class="title gap-12">附件信息</div>
          <el-link
            type="primary"
            v-if="detailInfo.isTemplate === 1"
            @click="showPrint('contract')"
          >
            {{ detailInfo.templateName }}
          </el-link>
          <el-link
            type="primary"
            v-if="detailInfo.isTemplate === 3"
            @click="showPrint('standard')"
            >查看合同附件</el-link
          >
          <upload
            v-if="detailInfo.isTemplate === 2"
            disabled
            v-model.trim="attchList"
            label="标准协议"
            :limit="5"
            :max-size="50"
            size="small"
          />
        </div>
      </template>
    </div>
    <sys-template
      v-model.trim="agreementDialogVisible"
      :readonly="true"
      :data="detailInfo"
      :supplierInfo="supplierInfo"
      :materialList="materialList"
    />
    <BottomPanel v-if="type !== 'detail' && $withPermission('gongxutong:sale:contract:audit')">
      <label style="float: left">
        <span class="common-font">审批意见：</span>
        <el-input
          placeholder="请输入审批意见"
          v-model.trim="approveMsg"
          style="width: 500px"
          :maxlength="50"
        ></el-input>
      </label>
      <template>
        <el-button
          style="margin-left: 1em"
          type="danger"
          plain
          @click="doApprove('reject')"
          >驳回</el-button
        >
        <el-button type="primary" @click="doApprove('pass')">通过</el-button>
      </template>
    </BottomPanel>
    <el-dialog
      title="标准合同附件"
      center
      :visible.sync="printDialogVisible"
      width="50%"
    >
      <contract-tmpl
        class="content-block"
        :basicInfo="printBasicInfo"
        :buyerInfo="printBuyerInfo"
        :goodsList="printGoodsList"
        :printerVisible.sync="printDialogVisible"
        :customerAddress="customerAddress"
        :terms="terms"
        :isIncludeWarranty="false"
        totalPriceKey="unitPriceTaxRate"
        flag="scm"
      />
    </el-dialog>
  </div>
</template>
<script>
import * as Moment from 'dayjs';
import xzTable from '@/components/xiaozi-ui/xz-table/src/table.vue';
import {
  queryDetail,
  queryLogListById,
  editCheckState,
  editContractState,
  supplierDetail,
  queryMaterialList,
  detailAccountingUnit,
} from '@/api/saleContract';
import setTableCols from './configs';
import SysTemplate from './sysTemplate.vue';
import BottomPanel from '@/components/common/bottomPanel';
import { logTypes } from '@/model/logTypes';
import Upload from '@/components/common/upload';
import ContractTmpl from '@/components/ContractTmpl';
import { Base } from '@/components/ContractTmpl/base';
import { decisionEnums, changeStatesEnums } from '@/model/saleContract';

export default {
  name: 'sale_contract_detail',
  components: {
    xzTable,
    BottomPanel,
    SysTemplate,
    Upload,
    ContractTmpl,
  },
  props: {
    id: {
      type: String,
    },
    type: {
      type: String,
    },
  },
  filters: {
    setEmpty (val) {
      return val ? val : '--';
    },
  },
  data () {
    return {
      titlePrefix: require('@/assets/title_prefix.svg'),
      activeKey: '1',
      decisionEnums,
      changeStatesEnums,
      printDialogVisible: false,
      agreementDialogVisible: false,
      approveMsg: '',
      detailInfo: {},
      materialList: [],
      suppliesColumns: setTableCols.call(this, 'suppliesOfDetail'),
      supplierInfo: {},
      logData: [],
      logColumns: [
        {
          title: '事件类型',
          dataIndex: 'logType',
          key: 'logType',
          width: 300,
          customRender: (text) => {
            let val = '--';

            for (let v of logTypes) {
              if (v.value === text) {
                val = v.label;
                break;
              }
            }

            return val;
          },
        },
        {
          title: '时间',
          dataIndex: 'createTime',
          key: 'createTime',
          width: 300,
          customRender: (text) => {
            return text ? Moment(text).format('YYYY-MM-DD HH:mm:ss') : '--';
          },
        },
        {
          title: '日志内容',
          dataIndex: 'content',
          key: 'content',
        },
      ],
      states: [
        '草稿',
        '待审核',
        '生效驳回',
        '执行中',
        '已完结',
        '已取消',
        '待确认',
        '已驳回',
      ],
      attchList: [],
      printBasicInfo: {},
      printGoodsList: [],
      printBuyerInfo: {},
      customerAddress: Base.address,
      terms: [],
      templateList: [],
    };
  },
  created () {
    this.getDetail();
    this.getLog();
  },
  methods: {
    convertToName (enums, value) {
      let label = '--';

      for (let v of enums) {
        if (Number(v.value) === Number(value)) {
          label = v.label;
          break;
        }
      }

      return label;
    },
    handleActiveChange (v) {
      this.activeKey = v;
    },
    showPrint (type) {
      if (type === 'standard') {
        this.agreementDialogVisible = true;
      } else {
        this.printDialogVisible = true;
      }
    },
    getDetail () {
      queryDetail({ id: this.id }).then(({ body }) => {
        body.newContract.isTaxName = body.newContract.isTax === 1 ? '是' : '否';
        body.newContract.stateName = this.states[body.newContract.state] || '';
        body.newContract.changeStateName
          = body.newContract.changeState === 1
            ? '供应商变更确认'
            : body.newContract.changeState === 2
              ? '供应商变更驳回'
              : body.newContract.changeState === '3'
                ? '已驳回'
                : '';
        body.newContract.payWayName = ['不限', '预付款', '账期付款', '背靠背'][body.newContract.payWay] || '';

        this.detailInfo = body.newContract;

        this.getMaterialList();

        if (this.detailInfo.isTemplate === 2) {
          this.attchList = this.detailInfo.annexList.map((t) => ({
            id: t.id,
            url: t.annexUrl,
            attachId: t.id,
            attachName: t.annexName,
          }));
        } else if (this.detailInfo.annexType === 1) {
          if (this.detailInfo.templateInfo) {
            this.templateList = this.detailInfo.templateInfo.termsList || [];
            this.detailInfo.templateId = this.detailInfo.templateInfo.id;
            this.detailInfo.templateName = this.detailInfo.templateInfo.templateName;

            this.terms = this.templateList.map(v => `${v.title}:${v.content}`);
          }
        }
        this.getDetailAccountingUnit(this.detailInfo.unitId);
        this.getCustomerDetail(this.detailInfo.supId);
      });
    },
    getMaterialList () {
      queryMaterialList({
        id: this.id,
        flag: 2,
        enable: false,
      }).then(({ body }) => {
        this.materialList = body.list;

        if (this.detailInfo.isTemplate !== 2) {
          this.printGoodsList = body.list.map(v => {
            let taxRate = '--';

            if (this.detailInfo.isTax) {
              taxRate = this.detailInfo.taxRate;
            }

            return {
              goodsName: v.goodsName,
              spec: v.specsNo,
              manufacturer: v.producer,
              productUnit: v.unitOfMsment,
              brandName: v.brandName,
              salesVolume: v.orderNum,
              unitPrice: v.unitPrice,
              unitPriceTaxRate: taxRate,
              money: (v.unitPrice * v.orderNum).toFixed(2),
              imageList: v.image ? v.image.split(',') : [],
            };
          });
        }
      });
    },
    getCustomerDetail (customerId) {
      supplierDetail({
        id: customerId,
        findContactPersonFlag: true,
        findBankFlag: true,
        findReceiverFlag: true,
      }).then((res) => {
        this.detailInfo.email = res.body.email;
        this.supplierInfo = res.body;

        if (this.detailInfo.isTemplate === 1 && this.detailInfo.annexType === 1) {
          const { body } = res;

          this.printBuyerInfo = {
            name: body.name,
            address:
              `${body.provinceName || ''}${body.cityName
                || ''}${body.areaName || ''}${body.detailAddress || ''}` || '--',
            phone: body.telephone || '--',
            fax: body.fax || '--',
            owner: this.detailInfo.supPerson,
            contactPhone: this.detailInfo.supPhone,
          };
        }
      });
    },
    getLog () {
      queryLogListById({
        id: this.id,
      }).then(({ body }) => {
        this.logData = body || [];
      });
    },
    doApprove (type) {
      let api = null;
      const userInfo = JSON.parse(this.$local.get('userInfo'));
      let param = {
        id: this.id,
        supIdea: this.approveMsg,
        updateUserId: userInfo.id,
        updateUserName: userInfo.name,
      };

      let msg = '';

      if (this.type === 'review') {
        api = editContractState;

        param.state = type === 'reject' ? 7 : 3; // 7->供应商生效驳回； 3->执行中

        msg = type === 'reject' ? '合同生效已驳回' : '审核通过';
      } else if (this.type === 'change') {
        api = editCheckState;

        param.state = type === 'reject' ? 2 : 3; // 2->变更已驳回； 3->已变更
        msg = type === 'reject' ? '合同变更已驳回' : '审核通过';
      }

      api(param).then(() => {
        this.$message({
          message: msg,
          type: 'success',
        });

        this.$router.back();
      });
    },
    getDetailAccountingUnit (id) {
      detailAccountingUnit({id: id}).then(({body}) => {
        this.printBasicInfo = {
          code: this.detailInfo.pcCode,
          signedDate: new Date(this.detailInfo.signDate).valueOf(),
          customerHead: body.accountName || '--',
          contactPhone: this.detailInfo.salesmanPhone || '--',
          fax: body.fax || '--',
          customerContact: this.detailInfo.salesmanName || '--',
          detailAddress: `${body.provinceName}${body.cityName}${body.areaName}${body.address}`,
        };
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@mixin tag_round() {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: normal;
}

.contract_detail_wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;

  .header {
    height: 52px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;

    .page_type {
      font-size: 16px;
      font-weight: bold;
      margin-left: 1em;
    }
  }

  .content {
    flex: 1;
    padding: 8px 0 0;
    overflow: auto;

    .gap-12 {
      margin-bottom: 12px;
    }

    .common {
      background-color: #fff;
      padding: 12px;
      margin-bottom: 6px;

      &.flex-row {
        display: flex;
        justify-content: space-between;
        padding-right: 0;
        padding-bottom: 0;

        .left {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .basic-info {
            display: flex;
            align-items: center;

            .img-wrapper {
              width: 40px;
              height: 40px;
              background-color: #E2F3FE;
              border-radius: 4px;
              margin-right: 6px;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .code {
              font-size: 14px;
              color: #929AA6;

              .status-0,
              .status-5 {
                @include tag_round();
                color: #1F2733;
                background-color: #F2F4F7;
              }

              .status-1,
              .status-6 {
                @include tag_round();
                background-color: #FEFEE5;
                color: #FAB007;
              }

              .status-3 {
                @include tag_round();
                background-color: #E2F3FE;
                color: #237FFA;
              }

              .status-4 {
                @include tag_round();
                background-color: #E5FEEB;
                color: #14CA64;
              }

              .status-2,
              .status-7 {
                @include tag_round();
                background-color: #FEE9E5;
                color: #FF5959;
              }
            }

            .customer {
              font-size: 16px;
              font-weight: 600;
            }
          }

          /deep/ .ant-tabs-bar {
            margin: 0;

            .ant-tabs-nav {
              .ant-tabs-tab {
                margin-right: 16px;
              }
            }
          }
        }

        .bg_money_wrapper {
          width: 258px;
          height: 112px;
          background: url('../../assets/bg_money.svg') no-repeat 0 0 / 96% 96%;
          padding: 20px;

          .title {
            font-size: 14px;
            font-weight: normal;
            line-height: 20px;
          }

          .value {
            font-size: 26px;
            font-weight: bold;
          }
        }
      }

      .title {
        font-weight: bold;
      }
    }
  }
}
</style>
